import { useRef, useState, useEffect, useMemo } from 'react';
import cx from 'classnames';
import MasterScheduleCell from '../../components/MasterScheduleCell';
import Portal from '../../../../../../../components/other/portal';
import useOutsideClick from '../../../../../../../hook/useOutsideClick';
import AddUnitRoleModal from '../../../AddUnitRoleModal';

const MasterScheduleTableRow = ({
  index,
  unit,
  roleName,
  cells,
  showNames,
  scheduleData,
  formData,
  selectedUser,
  sidebarAction,
  selectedAssignmentsToDelete,
  getScheduleData,
  handleCellClick,
  selectedCells,
  isFirstCnaRole,
  role,
  roleLabels,
  isFirstNurseRole,
  handleAddUnitRole,
  sundayDays,
}) => {
  const buttonRef = useRef();
  const dropdownRef = useRef();

  const [dropdownPos, setDropdownPos] = useState(null);
  const [isAddRoleDropdownOpen, setIsAddRoleDropdownOpen] = useState(false);
  const [addRoleData, setAddRoleData] = useState(null);

  useOutsideClick(dropdownRef, () => setIsAddRoleDropdownOpen(false));

  useEffect(() => {
    if (isAddRoleDropdownOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownPos({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
  }, [isAddRoleDropdownOpen]);

  return (
    <>
      <tr
        className={cx('unit-row', {
          'first-nurse-role': isFirstNurseRole,
          'first-cna-role': isFirstCnaRole,
        })}
      >
        {isFirstNurseRole && (
          <td rowSpan={unit.roles.length} className="unit-name-col">
            <div className="unit-name-col-wrapper">
              <button ref={buttonRef} onClick={(e) => setIsAddRoleDropdownOpen(true)} className="btn btn-outline unit-dropdown-btn">
                <>
                  <span data-tooltip-id={`${unit.id}-unit-tooltip`}>{unit.name}</span>
                </>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M9.99984 10.832C10.4601 10.832 10.8332 10.4589 10.8332 9.9987C10.8332 9.53846 10.4601 9.16536 9.99984 9.16536C9.5396 9.16536 9.1665 9.53846 9.1665 9.9987C9.1665 10.4589 9.5396 10.832 9.99984 10.832Z"
                    fill="#667085"
                  />
                  <path
                    d="M9.99984 4.9987C10.4601 4.9987 10.8332 4.6256 10.8332 4.16536C10.8332 3.70513 10.4601 3.33203 9.99984 3.33203C9.5396 3.33203 9.1665 3.70513 9.1665 4.16536C9.1665 4.6256 9.5396 4.9987 9.99984 4.9987Z"
                    fill="#667085"
                  />
                  <path
                    d="M9.99984 16.6654C10.4601 16.6654 10.8332 16.2923 10.8332 15.832C10.8332 15.3718 10.4601 14.9987 9.99984 14.9987C9.5396 14.9987 9.1665 15.3718 9.1665 15.832C9.1665 16.2923 9.5396 16.6654 9.99984 16.6654Z"
                    fill="#667085"
                  />
                  <path
                    d="M9.99984 10.832C10.4601 10.832 10.8332 10.4589 10.8332 9.9987C10.8332 9.53846 10.4601 9.16536 9.99984 9.16536C9.5396 9.16536 9.1665 9.53846 9.1665 9.9987C9.1665 10.4589 9.5396 10.832 9.99984 10.832Z"
                    stroke="#667085"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9.99984 4.9987C10.4601 4.9987 10.8332 4.6256 10.8332 4.16536C10.8332 3.70513 10.4601 3.33203 9.99984 3.33203C9.5396 3.33203 9.1665 3.70513 9.1665 4.16536C9.1665 4.6256 9.5396 4.9987 9.99984 4.9987Z"
                    stroke="#667085"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9.99984 16.6654C10.4601 16.6654 10.8332 16.2923 10.8332 15.832C10.8332 15.3718 10.4601 14.9987 9.99984 14.9987C9.5396 14.9987 9.1665 15.3718 9.1665 15.832C9.1665 16.2923 9.5396 16.6654 9.99984 16.6654Z"
                    stroke="#667085"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          </td>
        )}
        <td className="role-name-col">{roleName}</td>
        {cells
          .slice()
          .sort((a, b) => a.day - b.day)
          .map((cell, cellIndex) => (
            <td
              key={cellIndex}
              className={cx('shift-assignment-col', {
                'first-in-date': cellIndex % 3 === 0,
                'first-in-sunday': cellIndex % 3 === 0 && sundayDays.includes(cell.day - 1) && cellIndex !== 0,
              })}
              data-value={cell.day}
              onClick={() => handleCellClick(cell, role)}
              style={showNames ? { minWidth: '93px' } : {}}
            >
              <MasterScheduleCell
                cell={cell}
                scheduleData={scheduleData}
                selectedUser={selectedUser}
                selectedCells={selectedCells}
                formData={formData}
                sidebarAction={sidebarAction}
                selectedAssignmentsToDelete={selectedAssignmentsToDelete}
                showNames={showNames}
                getScheduleData={getScheduleData}
              />
            </td>
          ))}
      </tr>

      {isAddRoleDropdownOpen && dropdownPos && (
        <Portal>
          <ul
            ref={dropdownRef}
            className="unit-dropdown-menu"
            style={{
              position: 'absolute',
              top: `${dropdownPos.top}px`,
              left: `${dropdownPos.left}px`,
              zIndex: 9999,
            }}
          >
            <li>
              <button
                className="btn btn-left btn-full btn-text"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsAddRoleDropdownOpen(false);
                  setAddRoleData({ type: 'Nurse', unitId: unit.id });
                }}
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 3V17M3 10H17" stroke="#101828" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Add {roleLabels?.nurse_role_label}
              </button>
            </li>
            <li>
              <button
                className="btn btn-left btn-full btn-text"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsAddRoleDropdownOpen(false);
                  setAddRoleData({ type: 'CNA', unitId: unit.id });
                }}
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 3V17M3 10H17" stroke="#101828" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Add {roleLabels?.cna_role_label}
              </button>
            </li>
          </ul>
        </Portal>
      )}

      {!!addRoleData && (
        <AddUnitRoleModal
          handleAddUnitRole={handleAddUnitRole}
          closeModal={() => setAddRoleData(null)}
          addRoleData={addRoleData}
          roleLabels={roleLabels}
        />
      )}
    </>
  );
};

export default MasterScheduleTableRow;
